export enum ReportName {
  OPERATIONS = 'OPERATIONS',
  EMPLOYEES = 'EMPLOYEES',
  ORDER_ITEMS = 'ORDER_ITEMS'
}

export interface ReportDashboard {
  id: string
  name: string
}

export interface ReportsResponse {
  dashboards?: ReportDashboard[]
}

export interface ReportEmbedResponse {
  dashboardId: string
  embedUrl: string
  expiresInMinutes: number
}

export interface AvailableReport {
  id: string
  name: ReportName
  labelKey: string
}
